import styled, { css } from 'styled-components';
import {
  ParticipantsLayout, StatsColumn, ParticipantHeader, ParticipantRow,
} from './SorteoParticipants.styles';

export const MachinesLayout = styled(ParticipantsLayout)`
  /* Mismo tamaño de letra que ParticipantRow: la columna se calcula para que quepa un número de máquina de 8 dígitos
     (unos 4,75 em) más el relleno lateral, sin recortarlo. */
  --row-font-size: clamp(16px, min(2.1vw, 3.3vh), 38px);
  --machine-width: calc(var(--row-font-size) * 4.75 + 32px);
  --average-width: clamp(112px, 10vw, 180px);
  @media (max-width: 700px) {
    --machine-width: 86px;
    --average-width: 86px;
  }
`;

export const MachinesStats = styled(StatsColumn)`
  @media (max-width: 700px) { grid-template-columns: minmax(0, 1fr); }
`;

const machineColumns = css`
  grid-template-columns: var(--machine-width) minmax(0, 1fr) var(--average-width);
  & > span:first-child { justify-content: center; text-align: center; padding-inline: 6px; }
`;

export const MachineHeader = styled(ParticipantHeader)`
  ${machineColumns}
  & > span { padding-inline: 14px; }
  @media (max-width: 700px) { font-size: 12px; & > span { padding-inline: 6px; } }
`;

export const MachineRow = styled(ParticipantRow)`
  ${machineColumns}
  & > span { padding-inline: 14px; }
  .machine-number { color: #ffe69a; border-right: 1px solid #d5ab4f66; font-variant-numeric: tabular-nums; white-space: nowrap; }
  .participant-name > span { overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
  .participant-coupons { white-space: nowrap; font-size: clamp(14px, min(1.6vw, 2.5vh), 28px); }
  @media (max-width: 700px) { & > span { padding-inline: 6px; } .machine-number { font-size: 14px; } }
`;
